const store = {
  namespaced: true,
  state() {
    return {
      regions: [],

      advertRegions: [],
      regionLocations: [],
      locationSectors: [],

      categories: [],
      searchedRegions: [],
      activeCategories: [],

      currency: 'EUR',
      measureUnit: 'm2',
      offerType: 'all',
    }
  },
  getters: {
    regions: (state) => state.regions,

    advertRegions: (state) => state.advertRegions,
    regionLocations: (state) => state.regionLocations,
    locationSectors: (state) => state.locationSectors,

    categories: (state) => state.categories,
    searchedRegions: (state) => state.searchedRegions,
    activeCategories: (state) => state.activeCategories,

    currency: (state) => state.currency,
    measureUnit: (state) => state.measureUnit,
    offerType: (state) => state.offerType,
  },
  mutations: {
    SET_REGIONS: (state, items) => state.regions = items,

    SET_ADVERT_REGIONS: (state, items) => state.advertRegions = items,
    SET_REGION_LOCATIONS: (state, items) => state.regionLocations = items,
    SET_LOCATION_SECTORS: (state, items) => state.locationSectors = items,

    SET_CATEGORIES: (state, items) => state.categories = items,
    SET_SEARCHED_REGIONS: (state, items) => state.searchedRegions = items,
    SET_ACTIVE_CATEGORIES: (state, items) => state.activeCategories = items,
    GET_REGIONS: function(state, data) {
      const choosedLocations = data.queryData.location ? data.queryData.location.split(',').map(Number) : []
      const choosedSectors = data.queryData.sector ? data.queryData.sector.split(',').map(Number) : []

      if (data.items.length) {
        data.items = data.items.map(i => {
          let itemLocations = []

          i.region_locations.map(l => {
            const newSectors = []

            l.location_sectors.map(s => {
              newSectors.push({
                ...s,
                checked: choosedSectors.includes(s.id) ? true : false
              })
            })

            itemLocations.push({
              ...l,
              location_sectors: newSectors,
              checked: choosedLocations.includes(l.id) ? true : false
            })
          })

          const countChecked = itemLocations.reduce((count, item) => count + (item.checked ? 1 : 0), 0)

          return {
            ...i,
            isOpen: false,
            isRegion: true,
            checked: countChecked === itemLocations.length ? true : false,
            region_locations: itemLocations
          }
        })
      }

      state.regions = data.items
    },

    SET_CURRENCY: (state, type) => state.currency = type,
    SET_MEASURE_UNIT: (state, type) => state.measureUnit = type,
    SET_OFFER_TYPE: (state, type) => state.offerType = type,
  },
  actions: {
    setRegions: ({ commit }, items) => commit('SET_REGIONS', items),
    setAdvertRegions: ({ commit }, items) => commit('SET_ADVERT_REGIONS', items),
    setSearchedRegions: ({ commit }, items) => commit('SET_SEARCHED_REGIONS', items),
    setMeasureUnit: ({ commit }, item) => commit('SET_MEASURE_UNIT', item),
    setActiveCategories: ({ commit }, items) => commit('SET_ACTIVE_CATEGORIES', items),

    setCurrency: ({ commit }, currency) => commit('SET_CURRENCY', currency),
    setOfferType: ({ commit }, type) => commit('SET_OFFER_TYPE', type),

    fetchRegions: async function ({ commit }, data) {
      try {
        const res = await this.$axios({
          method: 'GET',
          url: `/api/regions/?only_adverts=true`,
        })
        commit('GET_REGIONS', {
          items: res.data,
          queryData: data.queryData
        })
      } catch (error) {
        console.dir(error)
      }
    },

    fetchRegionsAdvert: async function ({ commit }, data) {
      try {
        const res = await this.$axios({
          method: 'GET',
          url: `/api/advert-regions/`,
        })
        commit('SET_ADVERT_REGIONS', res.data)
      } catch (error) {
        console.dir(error)
      }
    },

    fetchRegionLocations: async function ({ commit }, data) {
      try {
        const res = await this.$axios({
          method: 'GET',
          url: `/api/advert-regions/${data.id}/locations/`,
        })
        commit('SET_REGION_LOCATIONS', res.data)
      } catch (error) {
        console.dir(error)
      }
    },

    fetchLocationsSectors: async function ({ commit }, data) {
      try {
        const res = await this.$axios({
          method: 'GET',
          url: `/api/sectors/?location=${data.id}`,
        })
        commit('SET_LOCATION_SECTORS', res.data)
      } catch (error) {
        console.dir(error)
      }
    },

    fetchCategories: async function ({ commit }) {
      try {
        const res = await this.$axios({
          method: 'GET',
          url: `/api/adverts-categories/`,
        })
        commit('SET_CATEGORIES', res.data)
      } catch (error) {
        console.dir(error)
      }
    },
  }
}

export default store
